import { render, staticRenderFns } from "./StudyMappingIndividualReviewByStudies.vue?vue&type=template&id=799498f5"
import script from "./StudyMappingIndividualReviewByStudies.vue?vue&type=script&lang=js"
export * from "./StudyMappingIndividualReviewByStudies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports